import React, { useRef, useState } from "react";
import { Card, Container } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import CommonTable from "../../components/tables/CommonTable";
import useAuth from "../../hooks/useAuth";
import { Globe } from "react-feather";
import moment from "moment-timezone";
import { NavLink } from "react-router-dom";

const ArchivedTrackers = () => {
  const [resultCount, setResultCount] = useState(null);
  const childRef = useRef();
  const { user } = useAuth();
  const curTime = useRef(moment());

  const columns = [
    {
      Header: "#Serial",
      accessor: "serial",
      Cell: (cell) => {
        if (user?.role === "Root") {
          return (
            <NavLink
              to={{
                pathname: "/archived-trackers/edit",
                search: `?id=${cell.row.original.id}`,
              }}
            >
              {cell.value}
            </NavLink>
          );
        } else {
          return <span>{cell.value}</span>;
        }
      },
    },
    {
      Header: "Model",
      accessor: "model",
      disableSortBy: true,
    },
    {
      Header: "Last Seen",
      accessor: "lastReport",
      type: "dateFromNow",
    },
    {
      Header: "Customer",
      accessor: "customerName",
      show: user?.role === "Root",
      disableSortBy: true,
      Cell: (cell) => (
        <NavLink
          to={{
            pathname: `/customers/edit`,
            search: `?id=${cell.row?.original?.customerId}`,
          }}
        >
          {cell.value}
        </NavLink>
      ),
    },
    {
      Header: "Linked",
      accessor: "customerId",
      type: "linkStatus",
      disableSortBy: true,
    },
  ];

  return (
    <>
      <Helmet defer={false} title="Archived Trackers" />
      <Container fluid className="p-0">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h1 className="h3 mb-0">
            <Globe className={"me-2"} />
            Archived Trackers{" "}
            {typeof resultCount === "string" && `(${resultCount})`}
          </h1>
        </div>
        <Card className="bg-white p-3">
          <CommonTable
            curTime={curTime.current}
            ref={childRef}
            setCountParent={setResultCount}
            apiName="archived-trackers"
            columns={columns}
          />
        </Card>
      </Container>
    </>
  );
};

export default ArchivedTrackers;
